import React from 'react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { Size } from '@lumapps/lumx/react';
import { UserBlock } from '@lumapps/user/components/UserBlock';
import { User } from '@lumapps/user/types';

import { DrawerSection, DrawerSectionProps } from '../DrawerSection';

export interface DrawerUserSectionProps extends DrawerSectionProps {
    /** user that performed the action */
    user?: Partial<User>;
    /** scope of the feature */
    scope: string;
    /** whether inactive users (disabled & deleted) should be flagged or not */
    shouldFlagInactiveUsers?: boolean;
}

/**
 * Displays a user in the context of a drawer
 * @family Drawer
 * @param DrawerUserSectionProps
 * @returns DrawerUserSection
 */
export const DrawerUserSection: React.FC<DrawerUserSectionProps> = ({
    user,
    scope,
    shouldFlagInactiveUsers,
    ...props
}) => {
    const { get } = useDataAttributes(scope);

    if (user && user.id) {
        return (
            <DrawerSection {...props}>
                <UserBlock
                    size={Size.s}
                    user={user}
                    shouldFlagInactiveUsers={shouldFlagInactiveUsers}
                    {...get({ element: 'section', type: 'user' })}
                />
            </DrawerSection>
        );
    }

    return null;
};
